import { BenefitWizardType } from "../constants/wizard-panels";
import { EnrollmentBenefitCategory } from "./enrollment-category";
import { OnboardingEnrollmentsItem } from "./enrollment-onboard";

export class EnrollmentManager extends EnrollmentBenefitCategory {
    selectedCategoryId: number;
    selectedCategoryName: string;
    enrollmentMode: OnboardingEnrollmentsItem;
    BenefitWizardType: BenefitWizardType;
    selectedBenefitName: string;
    selectedBenefitAvailable: string;

    constructor() {
        super();
        this.selectedCategoryId = 0
        this.selectedCategoryName = null;
        this.enrollmentMode = null;
        this.BenefitWizardType = null;
        this.selectedBenefitName = null;
        this.selectedBenefitAvailable = null;
    }
}